const COUNTRIES_OBJ = window.bigcommerce_config.countries;
export default function updateRegistration($) {
    addProvinceToLicense($('#bc-account-register-license-state'), $);
    addProvinceToLicense($('#bc-account-register-state'), $);
}

function addProvinceToLicense($stateField, $) {
    const states = COUNTRIES_OBJ.find(item => item.country === 'Canada').states.map((state) => {
        return `<option value="${state.state}" data-state-abbr="${state.state_abbreviation}">${state.state}</option>`;
    });

    $stateField.append(`<option value="" disabled>Select Province</option>`);
    $stateField.append(states);
    $("label[for='" + $stateField.attr('id') + "']").find('span').text('License State/Province');
}
